export default {"src":"/_next/static/media/user.1a25dfc9.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};